import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const logos = [{
  name: "Lista Civica Borelli",
  src: "https://borellisindaco.it/wp-content/uploads/2026/05/Alleanza-Verdi-Sinistra-Albano10cm@2x.png?v=g759bjkm0cg"
}, {
  name: "Partito Democratico",
  src: "https://borellisindaco.it/wp-content/uploads/2026/05/pd.png?v=0p63oe817gro"
}, {
  name: "Movimento 5 Stelle",
  src: "https://borellisindaco.it/wp-content/uploads/2026/05/mov.png?v=7pjre15uiws"
}, {
  name: "Alleanza Verdi Sinistra",
  src: "https://borellisindaco.it/wp-content/uploads/2026/05/casa-r.png"
}, {
  name: "Italia Viva",
  src: "https://borellisindaco.it/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-26-at-17.09.12-1-1.jpg?v=3asz9sj25uy"
}, {
  name: "Azione",
  src: "https://borellisindaco.it/wp-content/uploads/2026/05/274695593_262210502757943_2291766898422543541_n.png?v=wc7w6ck1epk"
}];
export default function IndustryPartners() {
  return <section data-section-id="224384" id="la-nostra-coalizione" className="bg-background border-y border-border/30 py-20 text-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col items-center">
        <div className="text-primary text-sm font-bold tracking-widest mb-12 flex items-center gap-2 font-default uppercase">
          <span className="text-[10px] text-secondary">●</span> La nostra Coalizione
        </div>
        
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 mb-16 !bg-[url(https://borellisindaco.it/wp-content/uploads/2026/05/4-1-scaled.png)] !text-[rgba(26,26,26,1)] md:gap-x-20 lg:gap-x-24">
          {logos.map((logo, i) => <div key={logo.name} data-index={i} className="flex items-center justify-center">
              <div className="block">
                <img src={logo.src} alt={`${logo.name} logo`} className="h-12 w-auto object-contain opacity-100 transition-all duration-500 ease-in-out !text-[rgba(207,207,207,1)] md:h-16" loading="lazy" />
              </div>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Button asChild className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-bold px-8 py-6 text-lg transition-transform hover:scale-105">
            <Link to="/CoalitionPage">
              Scopri la coalizione
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}